import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CursoTrial } from 'src/app/models/curso-trial';
import { Site } from 'src/app/models/site';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { Uf } from 'src/app/models/uf';

@Injectable({
  providedIn: 'root',
})
export class SiteService {
  public cursoTrialTopNavSubject = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient) {}

  getSiteLayout(id: string) {
    return this.http.get<Site>(`${environment.baseUrl}/sites/${id}`);
  }

  getCursoTrial() {
    return this.http.get<CursoTrial>(`${environment.baseApiUrl}/sites/${this.getCursoTrialId()}/trial`);
  }

  getCursoTrialId() {
    const curso = JSON.parse(localStorage.getItem('cursoTrial'));
    return curso.id;
  }

  getCursos(id: number) {
    return this.http.get<any[]>(`${environment.baseApiUrl}/sites/${id}/cursos`);
  }

  getEstados() {
    return this.http.get<Uf[]>(`${environment.baseApiUrl}/sites/estados`);
  }
}
